import { IFollowUpComplianceReport, IFollowUpDonorForList } from '@nkr/models/index';
import { Dispatch } from 'react-redux';
import { AuthActionCreators, IApplicationState } from '../';

export interface IFollowUpComplianceReportResponse {
    data: {
        success: boolean,
        message: string,
        results: IFollowUpComplianceReport[]
    }
}

export interface IFollowUpReconciliationReportResponse {
    data: {
        success: boolean,
        message: string,
        results: IFollowUpDonorForList[]
    }
}

export const ActionCreators = {
    getComplianceReport: (centerId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IFollowUpComplianceReportResponse> => {
        let options = {
            url: `${__API__}/follow-up/reports/compliance?centerId=${centerId != null ? centerId : ''}`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    getReconciliationReport: (centerId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IFollowUpReconciliationReportResponse> => {
        let options = {
            url: `${__API__}/follow-up/reports/reconciliation?centerId=${centerId != null ? centerId : ''}`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
}